<template>
  <div class="square-container">
    <el-main>
      <div class="tabs-wrapper">
        <el-tabs v-model="activeTab" class="demo-tabs">
          <el-tab-pane label="Latest" name="latest">
            <div class="scrollable-content">
              <div class="posts-container">
                <Post
                  v-for="(post,index) in latestPosts" 
                  :key="index"
                  :post="post"
                  @like="handleLike"
                  @comment="handleComment"
                  @login-required="showLoginDialog"
                />
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-main>

    <!-- Login Dialog -->
    <AuthDialog 
      :visible.sync="loginDialogVisible"
      :initial-mode="'login'"
      @login-success="handleLoginSuccess"
      @update:visible="handleAuthDialogClose"
    />
  </div>
</template>

<script>
import Post from '@/components/Post.vue'
import AuthDialog from '@/components/AuthDialog.vue'
import { postRequest } from '@/apis/front'

export default {
  name: 'Square',
  components: {
    Post,
    AuthDialog
  },
  data() {
    return {
      activeTab: 'latest',
      latestPosts: [],
      lastTime: new Date().getTime(),
      loginDialogVisible: false
    }
  },
  methods: {
    handleLike(postId) {
      console.log('Like post:', postId)
    },
    handleComment(postId) {
      console.log('Comment on post:', postId)
    },
    showLoginDialog() {
      this.loginDialogVisible = true
    },
    handleLoginSuccess() {
      // Refresh posts after successful login
      this.fetchRecentPosts()
    },
    handleAuthDialogClose(visible) {
      this.loginDialogVisible = visible
    },
    async fetchRecentPosts() {
      console.log(this.$store.state.user_id)
      
      const response = await postRequest('getRecentPostsNew', {
        user_id: this.$store.state.user_id || '',
        time: this.lastTime
      })
      
      if (response.data.code === 0) {
        const originalData = response.data.data
        this.latestPosts = Array(10).fill().flatMap(() => [...originalData])
      } else {
        this.$message.error(response.data.msg || 'Failed to fetch posts')
      }
    }
  },
  mounted() {
    this.fetchRecentPosts()
  }
}
</script>

<style scoped>
.square-container {
  width: 100%;
}

.el-header {
  background-color: #409EFF;
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0;
}

.el-header h1 {
  margin: 0;
}

.el-main {
  padding: 0;
  height: 100vh;
  overflow: hidden;
}

.posts-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
}

.tabs-wrapper {
  position: sticky;
  top: 0;
  background: white;
  z-index: 100;
  width: 100%;
}

.scrollable-content {
  height: calc(100vh - 120px);
  overflow-y: auto;
}
</style> 